import React from 'react'

export default function defaultRender(width, height, progress = 0) {
  return (
    <div
      style={{
        width,
        height,
        background: '#999',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <pre
        style={{
          color: '#fff',
          fontSize: '1rem',
          fontFamily: 'Menlo, monospace'
        }}
      >
        progress: {progress.toFixed(3)}
        <br />
        width: {width}px
        <br />
        height: {height}px
      </pre>
    </div>
  )
}
